module.exports = __webpack_public_path__ + "summer/img/bing_bg.8bcb10d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/present/bing_bg.png
// module id = 4AYg
// module chunks = 39